import { AllPlantCapacityResponse, PlantCapacityDto } from '@gtpl/shared-models/planning';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { PlantCapacityDTO } from './dto/plant-capacity-dto.';
import { PlantCapacityAdapter } from './dto/plant-capacity.adapter';
import { PlantCapacity } from './plant-capacity.entity';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { PlantCapacityRequest } from './dto/plant-capacity.request';
import { PlantCapacitiesRequest } from './dto/plant-capacity-request';


@Injectable()
export class PlantCapacityService {
    constructor(
        @InjectRepository(PlantCapacity)
        private plantCapacityRepo: Repository<PlantCapacity>,
        private plantCapacityAdapter: PlantCapacityAdapter,
    ){}
    async createPlantCapacity(plantCapacityDTO: PlantCapacityDTO[], isUpdate: boolean): Promise<AllPlantCapacityResponse> {
        console.log(plantCapacityDTO);
        try {
          let savedplantCapacityDtoData = []
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          for (const plantCapacityRecord of plantCapacityDTO){
            if (!isUpdate) {
              const countriesEntity = await this.getDuplicatePlantCapacity(plantCapacityRecord.plantCode,plantCapacityRecord.operation);
              if (countriesEntity) {
                //return new InformationMessageError(11104, "State already exists");
                throw new ErrorResponse(11104, 'Efficiency  already exists for variant and operation');
              }
            }
            // else{
            //   const resourceOperationEfficiencyEntity = await this.getCountryDetailsWithoutRelations(resourceOperationEfficiencyDTO.variantCode);
            //   if (resourceOperationEfficiencyEntity) {
            //     if(resourceOperationEfficiencyEntity.variantCode!=resourceOperationEfficiencyDTO.variantCode) {
            //       throw new ErrorResponse(11104, 'Resource efficiency already exists');      
            //   }
            //     return new InformationMessageError(11104, "State already exists");
            //   }
            // }
  
            const convertedPlantCapacity: PlantCapacityDTO = this.plantCapacityAdapter.convertDtoToEntity(plantCapacityRecord,isUpdate);
            const savedCountryEntity: PlantCapacity = await this.plantCapacityRepo.save(
              convertedPlantCapacity
            );
            const savedPlantCapacitiy: PlantCapacityDTO = this.plantCapacityAdapter.convertEntityToDto(convertedPlantCapacity);
            savedplantCapacityDtoData.push(savedPlantCapacitiy);
              // console.log(savedStateDto);
              
          }
          if (savedplantCapacityDtoData.length > 0) {
            // generating resposnse
            const response = new AllPlantCapacityResponse(true,1,isUpdate? 'Resource efficiency updated Successfully': 'Plant capacities Created Successfully')
            return response
          } else {
            // return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'Plant capacities saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
  
    }
    async getDuplicatePlantCapacity(plantCode: string,operation:string): Promise<PlantCapacity> {
    
        // tslint:disable-next-line: typedef
        const plantCapacityRes = await this.plantCapacityRepo.findOne({
          where: {plantCode: Raw(alias => `plant_code = '${plantCode}'`),operation: Raw(alias => `operation = '${operation}'`)},
        });
        if (plantCapacityRes) {
          return plantCapacityRes;
        } else {
          return null;
        }
    }

    async getCapacityByPlant( request: PlantCapacitiesRequest):Promise<AllPlantCapacityResponse>{
        const plantCapacityData = await this.plantCapacityRepo.find({where:{isActive:true,plantCode:request.plantCode},
        });
        if(plantCapacityData.length > 0){
          let plantCapacityDetails:PlantCapacityDto[] = []
          for(const efficiencyRecord of plantCapacityData){
            const obj = new PlantCapacityDto(efficiencyRecord.plantCapacityId,efficiencyRecord.operation,efficiencyRecord.plantCode,efficiencyRecord.machineCapacity,efficiencyRecord.peopleCapacity,efficiencyRecord.createdUser);
            plantCapacityDetails.push(obj);
          }
          return new AllPlantCapacityResponse(true,55555,'plant capacity data retrived successfully',plantCapacityDetails);
        }else{
          return new AllPlantCapacityResponse(false,99999,'No data found',undefined);
        }
      }
}
